import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Driverdashcamrental from './driver-dashcamrental.jsx';

export default class DriversDashcamrentals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_dashcamrental_accounts:  null,
      isLoading: false,
      url: props.url || '/api/v1/portal/drivers/dashcamrentals',
    };


    this.getDriversDashcamrentals();
  }

  getDriversDashcamrentals() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_dashcamrental_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversDashcamrentals = [];

    if (this.state.drivers_dashcamrental_accounts &&
        this.state.drivers_dashcamrental_accounts.length > 0) {
        this.state.drivers_dashcamrental_accounts.forEach(
          function(i) {
            DriversDashcamrentals.push(
              <Driverdashcamrental
                key={'drivers-dashcamrentals-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversDashcamrentals}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-dashcamrentals')) {
  ReactDOM.render(
    <DriversDashcamrentals
      url = {"/api/v1/portal/drivers/dashcamrentals"}
      message_if_none = 'Dash Camera not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-dashcamrentals'
    )
  );
}
